/**
 * Created by anatoly on 03.07.2025
 */

const BubblesStackHintView = function () {
    this.hintFinger = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("stack", this.show.bind(this));
};

BubblesStackHintView.prototype.show = function (move) {
    this.hide();

    this.hintFinger = FingerView.hintTap(move.target, {
        delay: move.delay / 1000,
        repeatDelay: move.interval / 1000
    });
};

BubblesStackHintView.prototype.hide = function () {
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;
};